<template>
  <div>
    <header>
      <!-- Navbar -->
      <div
        class="navbar flex items-center justify-center relative z-10 h-14"
        :style="navbarStyle"
      >
        <nav class="flex flex-wrap items-center justify-center md:justify-between w1200 py-4 md:py-0 px-4 text-lg">
          <div>
            <a href="/">
              <img
                :src="navbarLogo"
                class="mr-3 h-10 sm:h-10"
                alt="logotipo"
                @error="handleLogoError"
              />
            </a>
          </div>

          <!-- Menu gerado automaticamente da API (SEM Fotos do evento) -->
          <!-- ✅ MODIFICADO: Adicionado v-if="showMenu" -->
          <div class="flex hidden md:block md:flex">
            <ul v-if="showMenu" id="menu" class="text-xs uppercase hidden md:block md:flex md:justify-between md:pt-0 lg:m-3 md:px-10 mt-4" :style="{ color: customization?.navbar_text_color }">
              <li v-for="section in menuSections" :key="section.id">
                <a
                  class="font-normal py-2 md:px-4 md:py-2 md:border-b-0 border-b-2 block"
                  :href="section.href"
                  @click="closeMenu"
                >
                  {{ section.section_name }}
                </a>
              </li>
            </ul>

            <!-- Botão INSCREVA-SE -->
            <button>
              <a
                class="hidden md:block button-subscribe py-2 md:px-10 md:py-2 rounded-md items-center font-medium"
                href="#inscricao"
                :style="buttonStyle"
                @mouseenter="isButtonHovered = true"
                @mouseleave="isButtonHovered = false"
              >
                {{ customization?.navbar_button_label || 'INSCREVA-SE' }}
              </a>
            </button>
          </div>
        </nav>
      </div>

      <!-- Header Banner -->
      <section class="header-top">
        <div class="header-container">
          <div class="header-back" :style="headerBgStyle"></div>
        </div>
        <figure
          class="event-cover header-back"
          :style="headerBannerStyle"
        ></figure>
      </section>
    </header>

    <!-- Main Content -->
    <main class="flex justify-center">
      <slot :openModal="openModalForm"/>
    </main>

    <!-- Footer -->
    <footer class="footer-section" :style="footerStyle">
      <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Footer Content -->
        <div v-if="hasFooterContent" class="footer-content">
          <!-- About link (above social links) -->
          <a v-if="settings?.footer_about" :href="settings.footer_about" target="_blank" rel="noopener noreferrer" class="footer-about-link">
            Sobre
          </a>

          <!-- Social + Contact Links -->
          <div class="footer-links">
            <a v-if="settings?.footer_instagram" :href="settings.footer_instagram" target="_blank" rel="noopener noreferrer" class="footer-link" title="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              <span>Instagram</span>
            </a>
            <a v-if="settings?.footer_youtube" :href="settings.footer_youtube" target="_blank" rel="noopener noreferrer" class="footer-link" title="YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.13C5.12 19.56 12 19.56 12 19.56s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.43z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>
              <span>YouTube</span>
            </a>
            <a v-if="settings?.footer_website" :href="settings.footer_website" target="_blank" rel="noopener noreferrer" class="footer-link" title="Website">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              <span>Website</span>
            </a>
            <a v-if="settings?.footer_contact_email" :href="'mailto:' + settings.footer_contact_email" class="footer-link" title="Contato">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <span>{{ settings.footer_contact_email }}</span>
            </a>
          </div>
        </div>

        <!-- Bottom bar -->
        <div class="footer-bottom">
          <p>
            &copy; {{ currentYear }} {{ eventName }}. Todos os direitos reservados
          </p>
          <div class="footer-powered">
            <span>Feito com &#x1F496; por:</span>
            <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.22731 0.432367L7.04939 4.37495C7.28865 4.53746 7.42258 4.84294 7.42258 5.22666C7.42258 5.61039 7.28865 5.96402 7.04939 6.2093L1.22731 12.1984C0.974504 12.4587 0.678058 12.5219 0.416223 12.3715C0.154387 12.221 0.00390625 11.9005 0.00390625 11.4957V1.56398C0.00390625 1.15918 0.154387 0.784489 0.416223 0.543721C0.678058 0.301448 0.974504 0.26082 1.22731 0.432367Z" fill="url(#paint0_linear_2283_7250)"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.66502 2.73508C4.29843 4.39036 6.93183 6.04564 9.56523 7.70092C9.89027 7.90557 10.0724 8.23513 10.0724 8.61885C10.0724 9.00258 9.89027 9.33213 9.56523 9.53678C6.93183 11.1921 4.29843 12.8473 1.66502 14.5026C1.32193 14.7178 0.918645 14.7298 0.565017 14.5342C0.209884 14.3386 0.00523055 13.991 0.00523055 13.5862V2.00374C-0.00078866 1.55983 -0.0218574 1.143 0.212892 0.796891C0.480746 0.399623 0.906606 0.137788 1.35654 0.520008C0.267065 1.23178 1.20606 2.46722 1.66502 2.73658V2.73508Z" fill="url(#paint1_linear_2283_7250)"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.66458 2.73467C4.29798 4.38995 6.93138 6.04523 9.56479 7.70051C9.84317 7.87507 10.0162 8.14142 10.0599 8.45442C8.5039 9.58603 6.43028 10.2767 4.15201 10.2767C2.65022 10.2767 1.23872 9.97577 0.00327715 9.44759V2.00032C-0.00274206 1.55641 -0.0238085 1.13958 0.210941 0.793473C0.478795 0.396205 0.904655 0.13437 1.35459 0.51659C0.265114 1.22836 1.20411 2.4638 1.66308 2.73316L1.66458 2.73467Z" fill="url(#paint2_linear_2283_7250)"/>
              <defs>
                <linearGradient id="paint0_linear_2283_7250" x1="3.37316" y1="7.61629" x2="-1.64235" y2="5.22366" gradientUnits="userSpaceOnUse"><stop stop-color="#FBAD18"/><stop offset="1" stop-color="#EE2624"/></linearGradient>
                <linearGradient id="paint1_linear_2283_7250" x1="3.56108" y1="6.14345" x2="-3.40315" y2="9.92201" gradientUnits="userSpaceOnUse"><stop stop-color="#009EC0"/><stop offset="1" stop-color="#0054A1"/></linearGradient>
                <linearGradient id="paint2_linear_2283_7250" x1="1.79399" y1="5.27778" x2="9.97861" y2="7.24456" gradientUnits="userSpaceOnUse"><stop stop-color="#00A5B7"/><stop offset="1" stop-color="#00589A"/></linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </footer>

    <!-- WhatsApp Floating Button -->
    <WhatsAppFloat v-if="cleanWaPhone" :phone="cleanWaPhone" :eventName="settings?.event_name" :eventSlug="settings?.wa_router_slug" />
  </div>
</template>

<script>
import Register from './register.vue'
import WhatsAppFloat from './WhatsAppFloat.vue'
import { useLandingPage } from '@/composables/useLandingPage'

export default {
  name: "BaseLayout",
  components: { Register, WhatsAppFloat },
  props: {
    customization: { type: Object, default: () => ({}) },
    settings: { type: Object, default: () => ({}) }
  },

  setup() {
    const { sections } = useLandingPage()
    return { sections }
  },

  data() {
    return {
      openRegister: false,
      openAereoTermo: false,
      logoError: false,
      isButtonHovered: false
    }
  },

  computed: {
    cleanWaPhone() {
      const val = this.settings?.support_whatsapp
      if (!val) return null
      const clean = String(val).replace(/\D/g, '')
      return clean.length >= 10 ? clean : null
    },
    navbarLogo() {
      return this.logoError
        ? require('@/assets/logo.png')
        : this.customization?.navbar_logo || require('@/assets/logo.png')
    },

    headerBgStyle() {
      return this.customization?.header_bg_color ? { background: this.customization.header_bg_color } : {}
    },

    headerBannerStyle() {
      const styles = {}
      if (this.customization?.header_bg_color) styles.backgroundColor = this.customization.header_bg_color
      if (this.customization?.header_banner) {
        styles.backgroundImage = `url(${this.customization.header_banner})`
        styles.backgroundPosition = 'center'
      }
      return styles
    },

    navbarStyle() {
      const styles = {}
      if (this.customization?.navbar_bg_color) styles.backgroundColor = this.customization.navbar_bg_color
      if (this.customization?.navbar_text_color) styles.color = this.customization.navbar_text_color
      return styles
    },

    buttonStyle() {
      const styles = { transition: 'background-color 0.3s ease' }
      if (this.isButtonHovered && this.customization?.button_hover_color) {
        styles.backgroundColor = this.customization.button_hover_color
      } else if (this.customization?.button_color) {
        styles.backgroundColor = this.customization.button_color
      }
      return styles
    },

    eventName() {
      return this.settings?.event_name || 'Nosso Evento'
    },

    currentYear() {
      return new Date().getFullYear()
    },

    // AQUI ESTÁ A MÁGICA: remove "Fotos do evento" e "Formulário" do menu
    menuSections() {
      if (!this.sections) return []
      return this.sections.filter(section => {
        const key = section.section_key?.toLowerCase()
        return ![
          'gallery',
          'fotos',
          'photos',
          'fotos-do-evento',
          'event-photos',
          'galeria',
          'imagens',
          'register',
          'formulario',
          'formulário',
          'inscricao',
          'inscrição'
        ].includes(key)
      })
    },

    footerStyle() {
      const styles = {}
      if (this.customization?.footer_bg_color) styles.backgroundColor = this.customization.footer_bg_color
      if (this.customization?.footer_text_color) styles.color = this.customization.footer_text_color
      return styles
    },

    hasFooterContent() {
      const s = this.settings
      return s?.footer_instagram || s?.footer_youtube || s?.footer_website || s?.footer_about || s?.footer_contact_email
    },

    showMenu() {
      // Retorna true por padrão (se não existir ou se for true)
      // Retorna false apenas se explicitamente definido como false
      return this.customization?.show_menu !== 0
    }
  },

  methods: {
    openModalForm() {
      this.openRegister = !this.openRegister
    },
    openModalAereoTermo() {
      this.openAereoTermo = !this.openAereoTermo
    },
    openMenu() {
      const menu = document.querySelector('#menu')
      menu?.classList.toggle('hidden')
    },
    closeMenu() {
      const menu = document.querySelector('#menu')
      menu?.classList.toggle('hidden')
    },
    handleLogoError() {
      console.warn('Erro ao carregar logo da API, usando fallback')
      this.logoError = true
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  transition: background-color 0.3s ease, color 0.3s ease;
}
.event-cover {
  width: 100%;
  height: 400px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
@media (max-width: 768px) {
  .event-cover {
    height: 250px;
  }
}

/* Footer */
.footer-section {
  background: #111827;
  color: #9ca3af;
  padding: 0;
}
.footer-content {
  padding: 40px 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.footer-about-link {
  color: inherit;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: opacity 0.2s;
}
.footer-about-link:hover {
  opacity: 0.7;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
}
.footer-link {
  display: flex;
  align-items: center;
  gap: 6px;
  color: inherit;
  text-decoration: none;
  font-size: 14px;
  transition: opacity 0.2s;
}
.footer-link:hover {
  opacity: 0.7;
}
.footer-link svg {
  flex-shrink: 0;
}
.footer-bottom {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.footer-bottom p {
  font-size: 13px;
  color: inherit;
  opacity: 0.7;
  margin: 0;
}
.footer-powered {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: inherit;
  opacity: 0.7;
}
@media (max-width: 640px) {
  .footer-links {
    gap: 16px;
  }
  .footer-link span {
    display: none;
  }
  .footer-link svg {
    width: 24px;
    height: 24px;
  }
}
</style>